import React from 'react';

import { Card, FormItem, FormLayout, Radio, Button, Spacing } from '@vkontakte/vkui';

import styles from './index.module.css';
import { FeedbackFormProps } from './types';

export const FeedbackForm: React.FC<FeedbackFormProps> = ({ hasUserAgreed, onRadioChange, shareResult }) => {
  return (
    <div className={styles.agreementContainer}>
      <Card mode="shadow" className={styles.agreementCard}>
        <FormLayout>
          <FormItem top="Согласны ли Вы с результатом?">
            <Radio
              name="radio"
              value="yes"
              checked={typeof hasUserAgreed === 'boolean' && hasUserAgreed}
              onChange={() => onRadioChange(true)}
            >
                  Да
            </Radio>
            <Radio
              name="radio"
              value="no"
              checked={typeof hasUserAgreed === 'boolean' && !hasUserAgreed}
              onChange={() => onRadioChange(false)}
            >
                  Нет
            </Radio>
          </FormItem>
        </FormLayout>
      </Card>
      <Spacing size={20} />
      <Button
        stretched
        size="l"
        mode="primary"
        onClick={shareResult}
      >
              Поделиться результатом
      </Button>
    </div>
  );
};

